var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.77d21cf8718091aa102ff82bd424dd62.svg#b0';
                    var viewUrl = 'sprites.77d21cf8718091aa102ff82bd424dd62.svg#view-b0';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 169 66',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };